import React, { useEffect, useState, useSyncExternalStore } from "react";
import { Row, Col, Button } from "reactstrap";
import beeLogo from "../../assets/images/LOGO@3x.png";
import phoneimg from "../../assets/images/layouts/phone-img.png";
import MobileImg from "../../assets/images/layouts/mobile-img.png";
import "./index.css";
import uploadImg from "../../assets/images/upload-button.png";
import uploadImgMovil from "../../assets/images/upload-button-movil@3x.png";
import { useScreenHeight } from "../../helpers/useScreenHeight";
import { useIsDesktop } from "../../helpers/useIsDesktop";

export const ProfileSidePanel = (props) => {
    const { urlLogo, store, logo, uploadLogo, removeIcon } = props;
    const screenHeight = useScreenHeight();
    const isDesktop = useIsDesktop();

    return (
        <div
            style={{
                height: screenHeight,
                overflow: "hidden",
            }}
        >
            {isDesktop && (
                <Row className="">
                    <Col md={0} lg={{ offset: 2, size: 8 }}>
                        <div className="mt-5">
                            <img
                                src={beeLogo}
                                alt=""
                                className="img-fluid"
                                width="240"
                                height="80"
                            />
                        </div>
                    </Col>
                </Row>
            )}
            <Row className="mt-5">
                <Col sm={12} xs={12} lg={{ offset: 2, size: 8 }}>
                    <div className={`${isDesktop ? "" : "text-center"}`}>
                        <span className="title-profile-details ms-2">
                            Personalicemos tu perfil
                        </span>
                    </div>
                    <div className={`${isDesktop ? "" : "text-center"}`}>
                        <span className="subtitle-profile-details mt-3">
                            Adjunta el logotipo de tu empresa
                        </span>
                    </div>
                </Col>
            </Row>
            <Row className={`d-flex align-items-center mt-5`}>
                <Col sm={12} xs={12} lg={{ offset: 2, size: 2 }}>
                    <div
                        className="img-content-profile-details mt-2"
                        style={{ margin: "auto" }}
                    >
                        <img
                            src={
                                urlLogo && !logo
                                    ? urlLogo
                                    : logo
                                    ? URL.createObjectURL(logo)
                                    : isDesktop
                                    ? uploadImg
                                    : uploadImgMovil
                            }
                            onClick={uploadLogo}
                            className="img-fluid"
                            alt="Store logo"
                        ></img>
                        {!!logo && (
                            <div
                                className="text-white delete-button"
                                onClick={removeIcon}
                            >
                                <i class="fa-solid fa-x"></i>
                            </div>
                        )}
                    </div>
                </Col>
                {isDesktop && (
                    <Col sm={12} xs={12} lg={{ offset: 1, size: 5 }}>
                        <div className="">
                            {!!logo ? (
                                <div className="d-flex flex-column">
                                    <span className="store-title">
                                        {store.name}
                                    </span>
                                    <span
                                        className="store-title change-logo"
                                        onClick={uploadLogo}
                                    >
                                        Cambiar logo
                                    </span>
                                </div>
                            ) : (
                                <Button
                                    className="gradiant-button px-5 py-2"
                                    onClick={uploadLogo}
                                >
                                    Subir Logotipo
                                </Button>
                            )}
                        </div>
                    </Col>
                )}
            </Row>
            <Row>
                <Col xs={12} lg={{ offset: 2, size: 10 }}>
                    <Row className="d-flex align-items-center">
                        <Col xs={12} lg={12} xl={0}>
                            <div className="mobile-div">
                                <img
                                    src={MobileImg}
                                    alt=""
                                    className="phone-img"
                                />
                                <div className="phone-under-div ms-2 mt-1">
                                    <span className="back-link">
                                        <i class="bx bx-chevron-left"></i>
                                        Volver
                                    </span>
                                </div>
                                <div className="phone-under-div mt-5 ms-3">
                                    <div className="phone-img-img">
                                        {urlLogo && !logo ? (
                                            <img
                                                className="img-fluid phone-img-overlay"
                                                alt="store-logo"
                                                src={urlLogo}
                                            ></img>
                                        ) : logo ? (
                                            <img
                                                src={
                                                    logo
                                                        ? URL.createObjectURL(
                                                              logo
                                                          )
                                                        : null
                                                }
                                                alt=""
                                                className="img-fluid phone-img-overlay"
                                            />
                                        ) : (
                                            <img
                                                className="img-fluid phone-img-overlay"
                                                alt="logo"
                                                src={
                                                    store?.store_category_id
                                                        ?.category_logo
                                                }
                                            ></img>
                                        )}
                                    </div>
                                    <div className="phone-details ms-3">
                                        <div className="phone-details-heading">
                                            {store ? (
                                                <span>{store.name}</span>
                                            ) : (
                                                <span>
                                                    {" "}
                                                    Tienda{" "}
                                                    <span>Mayca One</span>
                                                </span>
                                            )}
                                        </div>
                                        <span className="phone-details-miam ms-1">
                                            <i class="bx bx-calendar"></i>
                                        </span>
                                        <span className="phone-details-miam ms-1">
                                            0 miembros
                                        </span>
                                        <p className="phone-details-low ms-1">
                                            Aun no eres Miembro
                                        </p>
                                        <button className="phone-button w-100 py-2 px-2">
                                            HACERME MIEMBRO
                                        </button>
                                    </div>
                                </div>
                                <div
                                    className={`phone-under-div-rest mt-5 ${
                                        isDesktop ? "ms-3" : ""
                                    }`}
                                >
                                    <img
                                        src={phoneimg}
                                        alt=""
                                        className="img-fluid phone-img-2 phone-img-overlay"
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

ProfileSidePanel.defaultProps = {
    isGeneric: false,
    imgWrapperClass: "mt-5 p-0 pt-4",
};
